import { useState } from 'react';
import emailjs from '@emailjs/browser';

const SERVICE_ID  = 'service_kpqxhsl';
const TEMPLATE_ID = 'template_nyhme9b';
const PUBLIC_KEY  = '0CvehwFDMwJc3pal8';

const BLOCKS = [
  {
    heading: 'VENUES',
    body: 'Hosting trivia in a bar, restaurants, and breweries brings the opportunities for strangers to come together. The comradery created by hosting TNL means patrons stay longer, order more food and drinks, and most importantly, return week after week to your establishment!',
  },
  {
    heading: 'HOST A PARTY WITH TNL',
    body: 'Birthdays, anniversaries, reunions, or simply for fun \u2013 TNL trivia games add an engaging twist to any party. Looking to host a corporate event? Have fun while promoting teamwork, critical thinking, communication, and friendly competition among colleagues.',
  },
];

const INPUT_CLASS =
  'w-full border text-dark text-sm rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gold transition-colors duration-200';

const INPUT_STYLE = {
  backgroundColor: '#FFFFFF',
  borderColor: '#DDDDDD',
  fontFamily: 'inherit',
};

const PLACEHOLDER_STYLE = `
  .tnl-input::placeholder {
    color: #999999;
    font-family: 'Boxen', sans-serif;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.05em;
  }
`;

const EMPTY = { name: '', email: '', venue: '', message: '' };

function AddTNL() {
  const [form, setForm]     = useState(EMPTY);
  const [status, setStatus] = useState(null); // null | 'sending' | 'success' | 'error'

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('sending');

    const templateParams = {
      name:    form.name,
      email:   form.email,
      message: form.venue
        ? `Venue / Event: ${form.venue}\n\n${form.message}`
        : form.message,
    };

    try {
      await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);
      setStatus('success');
      setForm(EMPTY);
    } catch {
      setStatus('error');
    }
  }

  const sending = status === 'sending';

  return (
    <section id="contact" className="w-full py-20 px-6 bg-dark" style={{ scrollMarginTop: '400px' }}>
      <style>{PLACEHOLDER_STYLE}</style>
      <div className="max-w-5xl mx-auto flex flex-col gap-16">

        <h2 className="font-boxen text-gold text-xl sm:text-2xl md:text-3xl leading-tight text-center">
          ADD TNL TO YOUR VENUE OR PRIVATE EVENT
        </h2>

        {/* Two-column text blocks */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {BLOCKS.map(({ heading, body }) => (
            <div key={heading} className="flex flex-col gap-4">
              <h3 className="font-poppins font-bold text-gold text-xl sm:text-2xl tracking-wide">
                {heading}
              </h3>
              <p className="font-poppins text-white text-sm sm:text-base leading-relaxed">
                {body}
              </p>
            </div>
          ))}
        </div>

        {/* Contact form */}
        <div className="w-full max-w-2xl mx-auto">
          <form onSubmit={handleSubmit} className="flex flex-col gap-5">

            <div className="flex flex-col gap-2">
              <label className="font-poppins text-white text-xs font-semibold tracking-widest uppercase">
                Name
              </label>
              <input
                type="text"
                placeholder="Your name"
                required
                value={form.name}
                onChange={e => set('name', e.target.value)}
                disabled={sending}
                className={`${INPUT_CLASS} tnl-input`}
                style={INPUT_STYLE}
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="font-poppins text-white text-xs font-semibold tracking-widest uppercase">
                Email
              </label>
              <input
                type="email"
                placeholder="your@email.com"
                required
                value={form.email}
                onChange={e => set('email', e.target.value)}
                disabled={sending}
                className={`${INPUT_CLASS} tnl-input`}
                style={INPUT_STYLE}
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="font-poppins text-white text-xs font-semibold tracking-widest uppercase">
                Venue / Event
              </label>
              <input
                type="text"
                placeholder="Venue name or event type"
                value={form.venue}
                onChange={e => set('venue', e.target.value)}
                disabled={sending}
                className={`${INPUT_CLASS} tnl-input`}
                style={INPUT_STYLE}
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="font-poppins text-white text-xs font-semibold tracking-widest uppercase">
                Message
              </label>
              <textarea
                rows={5}
                placeholder="Tell us about your venue or event..."
                required
                value={form.message}
                onChange={e => set('message', e.target.value)}
                disabled={sending}
                className={`${INPUT_CLASS} tnl-input resize-none`}
                style={INPUT_STYLE}
              />
            </div>

            <div className="flex flex-col items-center gap-4 pt-2">
              <button
                type="submit"
                disabled={sending}
                className="font-poppins font-bold tracking-widest text-dark bg-gold hover:bg-yellow-400 active:scale-95 transition-all duration-200 px-12 py-3 rounded-lg text-sm disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {sending ? 'SENDING…' : 'SUBMIT'}
              </button>

              {status === 'success' && (
                <p className="font-poppins text-sm font-semibold" style={{ color: '#4ade80' }}>
                  Message sent! We'll be in touch soon.
                </p>
              )}
              {status === 'error' && (
                <p className="font-poppins text-sm font-semibold" style={{ color: '#f87171' }}>
                  Something went wrong. Please try again.
                </p>
              )}
            </div>

          </form>
        </div>

      </div>
    </section>
  );
}

export default AddTNL;
